import * as React from "react";
import { forwardRef } from "react";
import { clsx } from 'clsx';
function _ChatAltLight(props, ref) {
    const { className, ...rest } = props;
    const classes = clsx('go-icon', className);
    return React.createElement("span", { className: classes, ref: ref, ...rest },
        React.createElement("svg", { width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24" },
            React.createElement("path", { stroke: "currentColor", d: "M20 12c0-3.771 0-5.657-1.172-6.828S15.771 4 12 4 6.343 4 5.172 5.172 4 8.229 4 12v6c0 .943 0 1.414.293 1.707S5.057 20 6 20h6c3.771 0 5.657 0 6.828-1.172S20 15.771 20 12Z" }),
            React.createElement("path", { stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", d: "M9 10h6M9 14h3" })));
}
const ChatAltLight = forwardRef(_ChatAltLight);
export { ChatAltLight };
